import clsx from 'clsx';
import ArrowSvg from '@/assets/icons/singleArrow.svg';
import DoubleArrowSvg from '@/assets/icons/doubleArrowSvg.svg';
import s from './PaginationArrow.module.scss';

interface Props {
  isDoubleArrow?: boolean;
  onClick: () => void;
  disabled?: boolean;
  reverse?: boolean;
}

export const PaginationArrow = ({ onClick, disabled, isDoubleArrow, reverse }: Props) => {
  const handleClick = () => !disabled && onClick();

  return (
    <button
      className={clsx(s.button, {
        [s.button_reversed]: reverse,
        [s.button_disabled]: disabled,
      })}
      onClick={handleClick}
    >
      {isDoubleArrow ? <DoubleArrowSvg /> : <ArrowSvg />}
    </button>
  );
};